import { invariant } from '@seen/core/invariant'
import { INCIDENT_TYPES } from '@seen/core/models/assessments/constants'
import { Incident } from '@seen/core/models/assessments/incident'
import type { ReactNode } from 'react'
import { useParams } from 'react-router'
import { GenericAssessmentPageComponent } from '#src/pages/shared/GenericAssessmentPageComponent.tsx'

export function ParticipantIncidentPage(): ReactNode {
  const { incidentId } = useParams()
  invariant(incidentId, 'Incident ID is required')

  return (
    <GenericAssessmentPageComponent
      assessmentId={incidentId}
      resourceClass={Incident}
      typeOptions={INCIDENT_TYPES}
      resourceNoun="incident"
    />
  )
}
